import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

// Footer logo asset.  Adjust the import path to match the location of
// `logo2.png` in your project.  For example, if your logos live in
// `src/assets` then the path would be '../assets/logo2.png'.
import logo2 from '../assets/logo2.png';

/**
 * Footer component providing quick links, a short description and
 * social media icons.  Uses the secondary logo for branding.  The
 * layout adapts across breakpoints.
 */
const Footer = () => (
  <Box component="footer" sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', py: 8 }}>
    <Container>
      <Grid container spacing={4}>
        {/* Logo and description */}
        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
           <Box component="img" src={logo2} alt="Acopiaserwa" sx={{ height: 44, mr: 2 }} />
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Acopiaserwa R.L.
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ color: 'primary.contrastText' }}>
            Tu socio en logística internacional.
          </Typography>
        </Grid>
        {/* Quick links */}
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
            Enlaces Rápidos
          </Typography>
          <Stack spacing={1}>
            <Link href="#inicio" underline="hover" color="inherit">
              Inicio
            </Link>
            <Link href="#servicios" underline="hover" color="inherit">
              Servicios
            </Link>
            <Link href="#sobre-nosotros" underline="hover" color="inherit">
              Sobre Nosotros
            </Link>
            <Link href="#aliados" underline="hover" color="inherit">
              Aliados
            </Link>
            <Link href="#faq" underline="hover" color="inherit">
              FAQ
            </Link>
            <Link href="#contacto" underline="hover" color="inherit">
              Contacto
            </Link>
          </Stack>
        </Grid>
        {/* Social media */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
            Síguenos
          </Typography>
          <Stack direction="row" spacing={2}>
            <Link href="#" color="inherit" aria-label="Facebook">
              <FacebookIcon fontSize="large" />
            </Link>
            <Link href="#" color="inherit" aria-label="Instagram">
              <InstagramIcon fontSize="large" />
            </Link>
            <Link href="#" color="inherit" aria-label="LinkedIn">
              <LinkedInIcon fontSize="large" />
            </Link>
          </Stack>
        </Grid>
      </Grid>
      <Typography
        variant="body2"
        sx={{ textAlign: 'center', mt: { xs: 4, md: 6 }, color: 'primary.contrastText' }}
      >
        © {new Date().getFullYear()} Acopiaserwa R.L. – Todos los derechos reservados.
      </Typography>
    </Container>
  </Box>
);

export default Footer;